__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "_N_E";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@zillow/cms-utils", "1.2.0", function() { return function() { return __webpack_require__(47394); }; }, 1);
			register("@zillow/frontier/dynamic", "1.62.1", function() { return function() { return __webpack_require__(96903); }; }, 1);
			register("@zillow/shopper-platform-config", "2.0.18", function() { return function() { return __webpack_require__(37435); }; }, 1);
			register("@zillow/web-platform-browser-rum", "0.1.5", function() { return function() { return __webpack_require__(82061); }; }, 1);
			register("next/dynamic", "14.2.32", function() { return function() { return __webpack_require__(5152); }; }, 1);
			register("next/head", "14.2.32", function() { return function() { return __webpack_require__(9008); }; }, 1);
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(73935); }; }, 1);
			register("react", "18.3.1", function() { return function() { return __webpack_require__(67294); }; }, 1);
			register("styled-components", "5.3.11", function() { return function() { return __webpack_require__(57833); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};